import { createRouteRef, createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';
import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

const settingsRouteRef = createRouteRef({
  id: "user-settings"
});
const userSettingsPlugin = createPlugin({
  id: "user-settings",
  routes: {
    settingsPage: settingsRouteRef
  }
});
const UserSettingsPage = userSettingsPlugin.provide(
  createRoutableExtension({
    name: "UserSettingsPage",
    component: () => import('./index-088c7808.esm.js').then((m) => m.SettingsPage),
    mountPoint: settingsRouteRef
  })
);

const userSettingsTranslationRef = createTranslationRef({
  id: "user-settings",
  messages: {
    language: "Language",
    change_the_language: "Change the language",
    theme: "Theme",
    theme_light: "Light",
    theme_dark: "Dark",
    theme_auto: "Auto",
    change_the_theme_mode: "Change the theme mode",
    select_theme: "Select {{theme}}",
    select_theme_auto: "Select Auto Theme",
    select_lng: "Select language {{language}}"
  }
});

export { UserSettingsPage as U, userSettingsTranslationRef as a, settingsRouteRef as s, userSettingsPlugin as u };
//# sourceMappingURL=translation-ecd113d9.esm.js.map
